import { useContext, useEffect, useState } from "react";
import { getServices, createServices, updateServices, deleteServices } from "../services/configurations/pointsOfAttention/services";
import { AppContext } from "../context";

type DataResponseType = "DATA" | "ID";
type ActionType = "CREATE" | "UPDATE" | "DELETE";

const handleActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createServices,
        fnMsg: t("PointsOfAttention.serviceApiCreateLabel"),
      };
      case "UPDATE":
        return {
          actionFn: updateServices,
          fnMsg: t("Users.usersApiUpdateLabel"),
        };
    case "DELETE":
      return {
        actionFn: deleteServices,
        fnMsg: t("Users.usersApiDeleteLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useServices = (type: DataResponseType) => {
  const {
    t,
    toast,
    appState: { selectedApp },
    setAppState,
  } = useContext(AppContext);
  const [dataService, setDataService] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFnService = () => {
    setDataService(null);
    setReload((prev) => prev + 1);
  };

  const serviceAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data, selectedApp?.tenantid!))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getServices(selectedApp?.tenantid!))
          .then((response) => {
            const serviceResponse = response?.data;
            setDataService(serviceResponse);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [toast, reload, type, setAppState]);

  return {
    dataService,
    serviceAction,
    reloadFnService,
  };
};